import { BookingTrackingTransporterDto, DeliveryTrackingDto } from './dtos/tracking';
import { sagwClient } from './clients';
import { bookingTrackingTransporterDtoToDeliveriesTracking, dtoToCaptainDetails } from './transformers/tracking';
import { DeliveriesTracking } from './models/deliveriesTracking';

export function fetchDeliveryTracking(deliveryId: string) {
  return sagwClient.get<DeliveryTrackingDto>(`/mot/user/deliveries/${deliveryId}/tracking`);
}

export function fetchDeliveryTrackingDriverDetails(deliveryId: string) {
  return fetchDeliveryTracking(deliveryId).then(dtoToCaptainDetails);
}

export async function fetchDeliveriesTracking(): Promise<DeliveriesTracking> {
  return sagwClient
    .get<BookingTrackingTransporterDto[]>(`/mot/user/deliveries/track`)
    .then(bookingTrackingTransporterDtoToDeliveriesTracking);
}
